module.exports = __webpack_public_path__ + "static/assets/1c7e4cb14ae88f4076f1ab4974677d8e.png";